export const LAY_DANH_SACH_PHONG_VE =
  "@quanLyDatVeReducer/LAY_DANH_SACH_PHONG_VE";
export const DAT_GHE = "@quanLyDatVeReducer/DAT_GHE";
export const DAT_VE = "@quanLyDatVeReducer/DAT_VE";
export const DAT_VE_HOAN_TAT = "@quanLyDatVeReducer/DAT_VE_HOAN_TAT";
